import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LoginCustomization } from '@core/interfaces';
import { UserLookupResult } from 'app/main/login/services/api/user-lookup.api.service';

@Component({
  selector: 'auth-password-step',
  templateUrl: './password-step.template.html'
})
export class PasswordStepComponent {
  @Input()
  public isLoading: boolean;

  @Input()
  public showPassword: boolean;

  @Input()
  public loginForm: FormGroup;

  @Input()
  public lookupResult: UserLookupResult;

  @Input()
  public loginCustomization: LoginCustomization;

  @Output()
  public authenticate: EventEmitter<void>;

  @Output()
  public returnToEmailStep: EventEmitter<void>;

  @Output()
  public authWithAd: EventEmitter<void>;

  @Output()
  public authWithGoogle: EventEmitter<void>;

  constructor() {
    this.authenticate = new EventEmitter<void>();
    this.authWithGoogle = new EventEmitter<void>();
    this.authWithAd = new EventEmitter<void>();
    this.returnToEmailStep = new EventEmitter<void>();
  }
}
